(function () {
  var revealTargets = document.querySelectorAll('[data-animate], [data-animate-group] [data-animate-child]');

  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    revealTargets.forEach(function (el) {
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion) {
    gsap.set(revealTargets, { opacity: 1, y: 0 });
  } else {
    document.querySelectorAll('[data-animate]').forEach(function (el) {
      var isFade = el.getAttribute('data-animate') === 'fade';
      gsap.fromTo(
        el,
        { opacity: 0, y: isFade ? 0 : 24 },
        {
          opacity: 1,
          y: 0,
          duration: 0.9,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: el,
            start: 'top 88%',
            toggleActions: 'play none none none',
          },
        }
      );
    });

    document.querySelectorAll('[data-animate-group]').forEach(function (group) {
      var children = group.querySelectorAll('[data-animate-child]');
      if (!children.length) return;
      gsap.fromTo(
        children,
        { opacity: 0, y: 24 },
        {
          opacity: 1,
          y: 0,
          duration: 0.9,
          ease: 'power3.out',
          stagger: 0.12,
          scrollTrigger: {
            trigger: group,
            start: 'top 88%',
            toggleActions: 'play none none none',
          },
        }
      );
    });
  }

  if (!prefersReducedMotion) {
    var mainSections = document.querySelectorAll('#MainContent > .shopify-section');
    mainSections.forEach(function (section, index) {
      if (index === 0) return; // never hide the hero on load
      if (section.querySelector('[data-animate], [data-animate-group]')) return; // already handled above
      gsap.fromTo(
        section,
        { opacity: 0, y: 28 },
        {
          opacity: 1,
          y: 0,
          duration: 0.9,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: section,
            start: 'top 90%',
            toggleActions: 'play none none none',
          },
        }
      );
    });
  }

  if (!prefersReducedMotion) {
    document.querySelectorAll('.linesse-imagery-banner__img').forEach(function (img) {
      var container = img.closest('.linesse-imagery-banner');
      gsap.fromTo(
        img,
        { scale: 1.0 },
        {
          scale: 1.12,
          ease: 'none',
          scrollTrigger: {
            trigger: container || img,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 0.6,
          },
        }
      );
    });
  }

  if (!prefersReducedMotion) {
    var ROTATION_RANGE = 32;
    var PHI = 78;

    document.querySelectorAll('.linesse-3d-viewer__stage, .linesse-3d-shelf-item__stage').forEach(function (stage) {
      var mv = stage.querySelector('model-viewer');
      if (!mv) return;

      var orbitAttr = mv.getAttribute('camera-orbit') || '0deg 78deg 220%';
      var radius = parseFloat(orbitAttr.split(' ')[2]) || 220;
      var state = { theta: -ROTATION_RANGE };

      gsap.fromTo(
        state,
        { theta: -ROTATION_RANGE },
        {
          theta: ROTATION_RANGE,
          ease: 'none',
          scrollTrigger: {
            trigger: stage,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 0.6,
          },
          onUpdate: function () {
            mv.cameraOrbit = state.theta + 'deg ' + PHI + 'deg ' + radius + '%';
          },
        }
      );
    });
  }

  if (!prefersReducedMotion) {
    var cartIcons = document.querySelectorAll('.header-icon-cart');
    if (cartIcons.length) {
      var bumpCart = function () {
        gsap.fromTo(
          cartIcons,
          { scale: 1 },
          { scale: 1.25, duration: 0.18, ease: 'power1.out', yoyo: true, repeat: 1 }
        );
      };
      document.addEventListener('eurus:cart:items-changed', bumpCart);
      document.addEventListener('cart:refresh', bumpCart);
    }
  }
})();
